import { FunctionComponent } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Logo from "./Logo/Logo";

const HeaderPublic: FunctionComponent = () => {
  return (
    <AppBar position="sticky" style={{ zIndex: 99999 }}>
      <Toolbar style={{ justifyContent: "space-between" }}>
        <div>
          <Logo />
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderPublic;
